module.exports = __webpack_public_path__ + "media/assets/img/portrait/small/avatar-s-1-680013ab3532206ec659173923b17b69.jpg";